<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>

<app-header></app-header>

<router-outlet></router-outlet>
<app-chat-box></app-chat-box>
